export default __webpack_public_path__ + "static/media/invalid-name@3x.bba58337.png";